import React from "react";
import { Route, Routes } from "react-router-dom";
import Help from "../Help";
import Header from "../Header";
import RaiseQueries from "./RaiseQueries";
import ViewQueries from "./ViewQueries";
import topImg from "../../Assets/svg/topVector.svg";
import btmImg from "../../Assets/svg/bottomVector.svg";

export default function Queries(props) {
  return (
    <div className="help-section">
     {props.isLoggedin &&  <Header isLogin={false} />}
      <div className="help-content">
        <Help />
      
     
      </div>
      <div className="btm-content">
        <span>
          We use cookies.{" "}
          <a href="https://www.idfcfirstbank.com/privacy-policy">Click here</a>{" "}
          to see our policy.
        </span>
        <span>
          <a href="https://www.idfcfirstbank.com/privacy-policy">Get Help</a>{" "}
        </span>
        <span>Copyright© 2024 IDFC FIRST Bank Ltd. All Rights Reserved</span>
      </div>
      <div className="top-img">
        <img src={topImg} alt="top img" />
      </div>
      <div className="btm-img">
        <img src={btmImg} alt="top img" />
      </div>
    </div>
  );
}
